import { useQuery } from "@tanstack/react-query";

import {
    BANNER_LEVEL_LABELS,
    BannerData,
    ENDPOINTS,
    QUERY_KEYS,
    useApi
} from "shared";

import { BannerDataFromApi } from "../types";

const useBannersList = (isOpen: boolean) => {
    const { getData } = useApi();

    return useQuery<BannerData[]>({
        queryKey: QUERY_KEYS.banners.list,
        queryFn: async () => {
            const { data } = await getData(ENDPOINTS.Banners);

            return data.data.map((banner: BannerDataFromApi): BannerData => {
                const { id, is_active, level, message } = banner;

                return {
                    id,
                    isActive: is_active,
                    level: level as BANNER_LEVEL_LABELS,
                    message
                };
            });
        },
        enabled: isOpen
    });
};

export { useBannersList };
